module.exports = __webpack_public_path__ + "static/media/but_link_img.354d8b55.svg";